<label class="inline-flex items-center cursor-pointer" *ngIf="mode === 'checkbox';else radio">
  <input *ngIf="!isRole" [checked]="checked" type="checkbox" class="form-checkbox h-5 w-5 " />
  <input *ngIf="isRole" (change)="checkboxChange.emit($event)" [checked]="checked" [id]="value" [value]="value" [formControl]="control" type="checkbox"
    class="form-checkbox h-5 w-5 " />
  <span class="truncate pl-2 ">{{text}}</span>
</label>

<!-- <pre> {{ item | json }} </pre> -->
<!-- <pre> {{ checked | json }} </pre> -->

<ng-template #radio>
  <label class="flex items-center cursor-pointer" (click)="clicked.emit()">
    <input style="opacity: 0" type="radio" [formControl]="control" [checked]="checked" [id]="item.id" [name]="radioName" [value]="item.value"
      class="form-checkbox h-5 w-5 " />
    <div [ngClass]="checked ? 'text-primary' : ''" class="ml-2">{{item.text}}</div>
  </label>
</ng-template>